import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import {
  getTrainerScoreGroup,
  getEvPotLossGroups,
  getEvLossGroups,
  getEvGroup,
} from '@/helpers/trainer'

// https://www.notion.so/gtowizard/Hand-History-Files-v2-c3a87a8c995f4555ae2487f627be2e5f

const table_mix = {
  mixins: [format_mix, float_mix],
  methods: {
    getStatusIcon(status) {
      return (
        {
          // V1: - files
          LIMIT_REACHED: 'mdi-stop-circle-outline',
          IN_QUEUE: 'mdi-file-clock-outline',
          PARTIALLY_FINISHED: 'mdi-progress-alert',
          UPLOADING: 'mdi-cloud-upload',
          PROCESSING: 'mdi-autorenew',
          ANALYSING: 'mdi-autorenew',
          FINISHED: 'mdi-check',
          ERROR: 'mdi-alert-circle-outline',

          // V2 - files
          // - UPLOADING when file created
          // - IN_QUEUE file uploaded and waiting parsing and analysis
          // - PROCESSING file started parsing
          // - ANALYSING parsing is finished and analysis started
          // - FINISHED finished
          // - ERROR
        }[status] || ''
      )
    },
    // getGmfGroupByGametype(gametype) {
    //   return this.$store.getters.gameformats.find(i => i.gametype === gametype)?.group || ''
    // },
    getGtoScoreGroup(num) {
      const res = getTrainerScoreGroup(num)
      return res
    },
    getEvPotLossGroup(num) {
      // let res = getEvGroup({ options: getEvPotLossGroups(), num: -1 })
      const res = getEvGroup({ options: getEvPotLossGroups(), num })
      return res
    },
    getEvLossGroup(num) {
      const res = getEvGroup({ options: getEvLossGroups(), num })
      // console.log(res)
      return res
    },

    tbl_setSortConf() {
      // let sortConf = this.l_sortConf
      let res = this.tbl_sortConf
      if (this.tbl_persistSortKey) {
        try {
          res = JSON.parse(localStorage.getItem(this.tbl_persistSortKey))
        } catch (error) {
          res = null
        }
      }
      if (
        res?.sortKey !== 'ordering_position' &&
        !Object.keys(this.thead).some(key =>
          this.thead[key].sortKeys
            ? this.thead[key].sortKeys.includes(res?.sortKey)
            : this.thead[key].sortKey === res?.sortKey,
        )
      ) {
        res = null
      }
      res = res || this.tbl_sortConf
      this.tbl_setSort(res)
      // console.log(res, this.thead)
    },
    tbl_handleColsSort({ item, colsSolKey }) {
      // debugger
      if (!item.sortKey) return
      const {sortKey} = item
      const res = {
        sortKey,
        sortOrder:
          sortKey === this.tbl_sortConf.sortKey
            ? this.tbl_sortConf.sortOrder === 'desc'
              ? 'asc'
              : 'desc'
            : this.tbl_sortConf.sortOrder,

        colsSortKey: {
          ...this.tbl_sortConf.colsSortKey,
          [colsSolKey]: sortKey,
        },
      }
      // console.log(res)
      // debugger
      this.tbl_setSort(res)
    },
    tbl_handleSort(item) {
      if (!item.sortKey) return
      const {sortKey} = item
      const res = {
        sortKey,
        sortOrder:
          sortKey === this.tbl_sortConf.sortKey
            ? this.tbl_sortConf.sortOrder === 'desc'
              ? 'asc'
              : 'desc'
            : this.tbl_sortConf.sortOrder,

        ...(this.tbl_sortConf.colsSortKey ? { colsSortKey: this.tbl_sortConf.colsSortKey } : {}),
      }
      // console.log(res)
      // debugger
      this.tbl_setSort(res)
    },
    tbl_setSort(res) {
      if (JSON.stringify(res) !== JSON.stringify(this.tbl_sortConf)) {
        this.tbl_sortConf = res
        // console.log(this.tbl_sortConf)
        // console.log(this.tcrud_params)
        if (this.tbl_persistSortKey) {
          localStorage.setItem(this.tbl_persistSortKey, JSON.stringify(this.tbl_sortConf))
        }
      }
    },
  },
}

export default table_mix
